import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "md:flex md:items-center bg-white border-b border-gray-200 flex py-4 md:pl-4" }
const _hoisted_2 = { class: "flex lg:flex-row flex-col" }
const _hoisted_3 = { class: "flex flex-col md:flex-row md:mr-auto" }
const _hoisted_4 = { class: "py-6" }

import DataTable from "@/components/tools/DataTable.vue";
import Pagination from "@/components/tools/Pagination.vue";
import TierDetailDialog from "@/components/dialogs/TierDetailDialog.vue";
import Navbar from "@/components/tools/Navbar.vue";
import { AxiosInstance } from "axios";
import { inject, onMounted, ref, watch } from "vue";
import { useStore } from "vuex";
import DateSelector from "@/components/tools/DateSelector.vue";
import TierCreateDialog from "@/components/dialogs/TierCreateDialog.vue";
import OperatorTierConfigDialog from "@/components/dialogs/OperatorTierConfigDialog.vue";
import { translate } from "@/utils/tools";


export default /*#__PURE__*/_defineComponent({
  __name: 'Tier',
  setup(__props) {

const store = useStore();
const axios = inject("$axios") as AxiosInstance;

const rowsData = ref([]);
const selectedRow = ref({});

const showTierDetailDialog = ref(false);
const showCreateNewTierDialog = ref(false);
const showOperatorTierConfig = ref(false);
const isLoaded = ref(false);

const fetchUserTiers = async () => {
  isLoaded.value = false;
  const { data } = await axios.post(
    `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/cms/oper-tiers/tier_list`,
    {
      operator_id: store.state.selectedOperator.operatorId,
      reward_type: 'LOYALTY_POINT'
    }
  );
  rowsData.value = data.sort(function (a: any, b: any) {
    return a.min_turnover - b.min_turnover;
  });
  isLoaded.value = true;
};

const columns = ref([
  { label: translate("messages.playerTier.name"), field: "name" },
  {
    label: translate("messages.playerTier.minTurnover"),
    field: "min_turnover",
    format: (data: any) =>
      (data.min_turnover / 100).toLocaleString("en", {
        useGrouping: true,
        minimumFractionDigits: 2,
      }),
  },
  {
    label: translate("messages.playerTier.maxTurnover"),
    field: "max_turnover",
    format: (data: any) =>
      (data.max_turnover / 100).toLocaleString("en", {
        useGrouping: true,
        minimumFractionDigits: 2,
      }),
  },
  {
    label: translate("messages.playerTier.rewardAmount"),
    field: "reward_amount",
    format: (data: any) => data.reward_amount.toLocaleString("en", {
      useGrouping: true,
      minimumFractionDigits: 0,
    }),
  },
  { label: translate("messages.playerTier.rewardType"), field: "reward_type" },
  {
    label: "",
    // label: translate("messages.playerTier.activated"),
    field: "is_active",
    isToggle: true,
    function: async (data: any) => {
      await axios.post(
        `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/cms/oper-tiers/update-tier`,
        { ...data, is_active: !data.is_active }
      );
    },
    permission: "TIER.MANAGE",
  },
  {
    label: "",
    field: "",
    isFunction: true,
    function: (data: any) => {
      selectedRow.value = { id: data.id, name: data.name, min_turnover: data.min_turnover / 100, max_turnover: data.max_turnover / 100, reward_amount: data.reward_amount };
      showTierDetailDialog.value = true;
    },
    format: (data: any) => translate("messages.playerTier.updateTier"),
    class: (data: any) => "text-white bg-blue-400 cursor-pointer",
    permission: "TIER.MANAGE",
  },
]);

onMounted(async () => {
  await fetchUserTiers();
});

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Navbar, {
      title: _ctx.$t('messages.playerTier.tier')
    }, null, 8, ["title"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (_unref(store).state.user.permissions.includes('TIER.MANAGE'))
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (showOperatorTierConfig.value = true)),
                class: "md:ml-3 inline-flex items-center px-3 py-1 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-500 hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-white focus:ring-blue-500"
              }, [
                _createVNode(_component_font_awesome_icon, {
                  class: "text-white mr-2",
                  icon: ['far', 'key'],
                  transform: ""
                }),
                _createTextVNode(" " + _toDisplayString(_ctx.$t("messages.playerTier.operatorTierConfig")), 1)
              ]))
            : _createCommentVNode("", true),
          (_unref(store).state.user.permissions.includes('TIER.MANAGE'))
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                type: "button",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (showCreateNewTierDialog.value = true)),
                class: "md:ml-3 inline-flex items-center px-3 py-1 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-500 hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-white focus:ring-blue-500"
              }, [
                _createVNode(_component_font_awesome_icon, {
                  class: "text-white mr-2",
                  icon: ['fas', 'plus'],
                  transform: ""
                }),
                _createTextVNode(" " + _toDisplayString(_ctx.$t("messages.playerTier.addNewTier")), 1)
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(DataTable, {
        data: rowsData.value,
        columns: columns.value,
        isLoaded: isLoaded.value
      }, null, 8, ["data", "columns", "isLoaded"])
    ]),
    _createVNode(TierDetailDialog, {
      show: showTierDetailDialog.value,
      "onUpdate:show": _cache[2] || (_cache[2] = ($event: any) => ((showTierDetailDialog).value = $event)),
      form: selectedRow.value,
      "onUpdate:form": _cache[3] || (_cache[3] = ($event: any) => ((selectedRow).value = $event)),
      onUpdate: _cache[4] || (_cache[4] = ($event: any) => (fetchUserTiers()))
    }, null, 8, ["show", "form"]),
    _createVNode(TierCreateDialog, {
      show: showCreateNewTierDialog.value,
      "onUpdate:show": _cache[5] || (_cache[5] = ($event: any) => ((showCreateNewTierDialog).value = $event)),
      onCreated: _cache[6] || (_cache[6] = ($event: any) => (fetchUserTiers()))
    }, null, 8, ["show"]),
    _createVNode(OperatorTierConfigDialog, {
      show: showOperatorTierConfig.value,
      "onUpdate:show": _cache[7] || (_cache[7] = ($event: any) => ((showOperatorTierConfig).value = $event))
    }, null, 8, ["show"])
  ], 64))
}
}

})